module.exports = __webpack_public_path__ + "img/interaction-wh-first-response-time.362ee72f.png";